/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_TitleInputs */

const da_billing_title = /** @type {(inputs: Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement og betaling`)
};

/** @type {(inputs: Billing_TitleInputs) => LocalizedString} */
const en_billing_title = da_billing_title;

/**

* @param {Billing_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_title = /** @type {((inputs?: Billing_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_title(inputs)
	return /** @type {LocalizedString} */ ("Abonnement og betaling")
});